module.exports = __webpack_public_path__ + "img/tool_essentials.5f70685d.png";